import { PaginationDataProps, PromiseResponseProps } from "@/config/types/common";
import request from "@/utils/request";

export function getActivityList(): PromiseResponseProps<
  {
    activityNo: string;
    activityName: string;
    activityDesc: string;
    sortNum: number;
  }[]
> {
  return request({
    url: "/cultural_sports_activity/v1/activity_select",
    method: "post",
  });
}
export function activityApply(data: {
  activityNo: string;
  realName: string;
  userId: string;
  gongHuiId: string;
  gongHuiName: string;
  phone: string;
  applyRemark: string;
}): PromiseResponseProps<null> {
  return request({
    url: "/cultural_sports_activity/v1/info_report",
    method: "post",
    data,
  });
}

export function activityApplyrRecords(data: {
  pageNum: number;
  pageSize: number;
}): PromiseResponseProps<
  PaginationDataProps<{
    content: string;
    applyStatus: number;
    applyStatusDesc: string;
  }>
> {
  return request({
    url: "/cultural_sports_activity/v1/report_records",
    method: "post",
    data,
  });
}
